<template>
  <div class="sidebar pt-0" :data-color="backgroundColor">
    <div class="logo">
      <!-- <div class="row" style="padding: 0em 2em 0em 2em;">
          <div class="col-md-12 col-12">
            <img src="/logo.png">
          </div>
      </div>-->
      <div style="text-align:center">
        <img class="logo-image" style="max-height:5em;" v-if="!brandLogoUrl" src="@/assets/img/logo.png" />
        <img class="logo-image" style="max-height:5em;" v-if="brandLogoUrl" :src="brandLogoUrl" alt />
      </div>

      <!-- <a href="#" class="simple-text logo-normal">
        {{title}}
      </a>-->
      <!-- <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-simple btn-icon btn-neutral btn-round" @click="minimizeSidebar">
          <i class="now-ui-icons text_align-center visible-on-sidebar-regular"></i>
          <i class="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"></i>
        </button>
      </div>-->
    </div>
    <div class="sidebar-wrapper pb-0" ref="sidebarScrollArea">
      <slot></slot>
      <ul class="nav mt-2">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink"></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
      <div v-if="brandLogoUrl && !appSettings.whiteLabelled" style="text-align: center; margin-top:1em;">
        <p style="color: white; margin-top: 1em; margin-bottom: 0em;">Powered by</p>
        <img style="padding: 1em 2em 1em 2em; width:100%" class="logo-img" src="@/assets/img/teslon-carenation-sm.png" alt />
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "sidebar",
  async mounted() {
    if (this.settings.brandLogo && this.settings.tenant) {
      let tenant = await this.$store.dispatch(
        "getTenant",
        this.settings.tenant
      );
      this.brandLogoUrl = await this.$store.dispatch(
        "getBrandLogo",
        tenant.name
      );
    }
  },
  data() {
    return { brandLogoUrl: null };
  },
  computed: {
    settings() {
      return this.$store.state.settings;
    }
  },
  props: {
    title: {
      type: String,
      default: "Carenation-Clinic",
    },
    backgroundColor: {
      type: String,
      default: "",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: require("@/assets/img/icon-vue.png"),
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {

  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
<style scoped>
.sidebar {
  border-top-right-radius: 1em;
  overflow: hidden;
}

.logo-image {
  max-height: 8em;
  width: auto !important;
  padding-top: 0.5em;
  padding-inline-start: 1em;
  padding-inline-end: 1em;
}
</style>
